/**
 * Created by glenn on 7/21/2017.
 */

import React = require('react')
import {store, iStore} from './store';
import {colorNa, colorUnknown, colorNotDet} from './styleAndPopup';
import {connect} from 'react-redux';
import {makeBlueGreenRedGradient} from 'webmapsjs/dist/util/colors';


class _Legend extends React.Component<{ min: number, max: number }, null> {

    render() {

        let liList = [];

        liList.push(<li key="No Data">
            <hr style={{backgroundColor: colorNa}}/>
            N/A (No Detector)
        </li>);

        liList.push(<li key="Unknown">
            <hr style={{backgroundColor: colorUnknown}}/>
            Unknown (Data Not Released)
        </li>);

        liList.push(<li key="Undetermined">
            <hr style={{backgroundColor: colorNotDet}}/>
            Data Available, Not Processed
        </li>);

        if (this.props.max == null || this.props.min == null) {
            // pass
        }

        else if (this.props.min == this.props.max) {
            let grad = makeBlueGreenRedGradient(-100, this.props.max, true);
            let color = grad(this.props.max);
            liList.push(<li key="high-val">
                <hr style={{backgroundColor: color}}/>
                {this.props.max}
            </li>);
        } else {
            let range = this.props.max - this.props.min;
            let step = range / 6;

            let grad = makeBlueGreenRedGradient(this.props.min, this.props.max, true);

            for (let i = 0; i < 7; i++) {
                let v = this.props.min + i * step;
                let color = grad(v);
                liList.push(<li key={v.toFixed(2)}>
                    <hr style={{backgroundColor: color}}/>
                    {v.toFixed(2)}
                </li>);
            }
        }

        return <div>
            <h4 style={{margin: '7px 0'}}>Legend</h4>
            <ul className="legend-list" style={{listStyle: 'none'}}>
                {liList}
            </ul>
        </div>
    }
}


function mapStateToProps(state: iStore) {
    if (!state.data.stats) {
        return {
            min: 10,
            max: 100
        };
    }

    let stat = state.data.stats[state.year.toFixed()][state.dataType][state.timePeriod][state.displayMethod];


    if (!stat) {
        return {
            min: undefined,
            max: undefined
        }
    }


    return {
        min: stat.min,
        max: stat.max
    };
}


export const Legend = connect(
    mapStateToProps,
)(_Legend);